export default __webpack_public_path__ + "static/airbnb-10-480883379a344ca2ef2107ba03256c84.png";